import React from 'react';
import { useTranslation } from 'react-i18next';
import { SectionTitle } from '@/features/marketplace/components/section-title';
import HousingSteps from '../guidelines';

const ApplyGuidelines: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="mt-4 flex flex-col items-center justify-center">
      <div style={{ borderColor: '#E8E8E8' }} className="w-full border-t border-solid">
        <SectionTitle
          subTitle={t('js.components.house_tabs.how_it_works') as string}
          className="mt-8 "
        >
          {t('js.components.house_tabs.how_it_works') as string}
        </SectionTitle>
      </div>
      <HousingSteps/>
    </div>
  );
};

export default ApplyGuidelines;
